import * as z from 'zod';

export type ServicePlanFormSchemaValues = z.infer<typeof servicePlanFormSchema>;
export const servicePlanFormSchema = z.object({
    name: z.string().nonempty(),
    code: z.string().nonempty(),
    description: z.string().optional().nullable(),
    external_service_plan_id: z.string().max(64).optional().nullable(),
    invoice_name: z.string().optional().nullable(),
    category: z.string().optional().nullable(),
});
